import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { PlantServiceService } from '../../../../services/dashboard/solar/plant-service.service';
import { Router, RouterLink, ActivatedRoute, ParamMap } from '@angular/router';
import { API_BASE$ } from 'src/app/shared/index';
import { combineLatest } from 'rxjs';
import { CommonService, UtilitiesService } from 'src/app/services/index';
@Component({
  selector: 'app-architecture',
  templateUrl: './architecture.component.html',
  styleUrls: ['./architecture.component.scss']
})
export class ArchitectureComponent implements OnInit {
  siteId: string;
  imageUrl = '';
  constructor(private activeRoute: ActivatedRoute, private plantService: PlantServiceService, private cd: ChangeDetectorRef,private utilitiesService: UtilitiesService,private commonService: CommonService) {
    // this.siteId = this.activeRoute.snapshot.queryParams['siteId'];
  }

  ngOnInit() {
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams})
    );
    // Subscribe to the single observable, giving us both
    urlParams.subscribe(routeParams => {
      // routeParams containing both the query and route params
      // this.loadUserDetail(routeParams.id, routeParams.type);
      this.siteId = routeParams.siteId;
      this.plantService.getAltSourcesDetails(this.siteId)
        .subscribe(data => {
          if (data !== undefined && data !== '' && data.attachments !== null && data.attachments !== undefined) {
            const url = this.commonService.getplantSolarLayoutUrl(this.siteId);
            this.utilitiesService.displayPlantSolarLayout(url);
            // this.imageUrl = `${API_BASE$}/${data.attachments.renderUrl}`;
          }
        });
    });
  }

}
